import type { LucideIcon } from 'lucide-react'

import { cn } from '@/utils'

const LINE_WIDTHS = ['w-full', 'w-4/5', 'w-11/12', 'w-3/5', 'w-5/6']

interface PaperSheetProps {
  label: string
  icon: LucideIcon
  className?: string
}

// A small drawn statement page: a labelled header over rows of text.
export const PaperSheet = ({
  label,
  icon: Icon,
  className,
}: PaperSheetProps) => (
  <div
    className={cn(
      'flex h-32 w-24 flex-col rounded-md border bg-white p-2.5 shadow-sm',
      className,
    )}
  >
    <div className="flex flex-1 flex-col gap-2">
      <div className="flex items-center gap-1">
        <Icon aria-hidden className="size-3 shrink-0 text-brand-deep" />
        <span className="truncate text-[9px] font-semibold text-blue-7">
          {label}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5">
        {LINE_WIDTHS.map((width) => (
          <span
            key={width}
            className={cn('h-1 rounded-full bg-blue-2', width)}
          />
        ))}
      </div>
      <span className="h-1.5 w-2/5 self-end rounded-full bg-blue-3" />
    </div>
  </div>
)
